import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { pickerBubbleStyle, pickerInlineStyle, pickerHistoryStyle } from '../common.styled';
import { RangePicker as RCPicker } from 'rc-picker';
import { PickerKinds } from './range-picker';

const STYLE_MAP = new Map<PickerKinds | undefined, FlattenSimpleInterpolation>([
  ['bubble', pickerBubbleStyle],
  ['inline', pickerInlineStyle],
  ['history', pickerHistoryStyle],
  [undefined, pickerInlineStyle],
]);

export const RangePickerSC = styled(RCPicker)<{ kind?: PickerKinds }>`
  ${({ kind }) => STYLE_MAP.get(kind)}
`;
